import { InputEmail } from '@/components/Input/Email/InputEmail';
import { CFormItemBase, type CFormItemProps, buildCFormItem } from '../CFormItem';
type Props = CFormItemProps & {
  value?: string;
  onChange: (value?: string) => void;
};

/**
 * Card-based Form / EmailItem
 */
export const CFormEmailItem = buildCFormItem((props: Props) => {
  return <CFormItemBase {...props} readComponent={props.value} writeComponent={<InputEmail value={props.value ?? ''} onChange={value => props.onChange(value || undefined)} />} />;
});